<template>
  <v-dialog
    v-model="buyOrderEditDialog"
    persistent
    max-width="600"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        depressed
        outlined
        v-on="on"
      >
        Muokkaa julkisia tietoja
      </v-btn>
    </template>
    <v-card>
      <div class="helmi-card-title pl-4 pt-4">
        Muokkaa tekstiä ja tilaa
      </div>
      <v-card-text class="pt-3 pb-2">
        <v-textarea
          v-model="buyOrder.description"
          label="Toimeksiannon kuvaus (julkinen)"
          class="mt-0 mb-0"
          auto-grow
          hide-details
          outlined
          rows="8"
        />
        <v-select
          v-model="buyOrder.status"
          class="mt-4"
          :items="statuses"
          label="Toimeksiannon tila"
          hide-details
          outlined
        />
      </v-card-text>
      <v-card-actions class="pb-4 pr-4">
        <v-spacer/>
        <v-btn
          text
          @click="buyOrderEditDialog = false"
        >
          Peruuta
        </v-btn>
        <v-btn
          color="primary"
          :loading="savingBuyOrder"
          text
          @click="save()"
        >
          Tallenna
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import _ from 'lodash';
import { apiPost } from '../api';

export default {
  props: {
    buyOrder: {
      type: Object,
      default: () => {},
    },
    currentStatus: {
      type: String,
      default: () => null,
    },
  },
  data: () => ({
    buyOrderEditDialog: false,
    savingBuyOrder: false,
    statuses: [{
      value: 3,
      text: 'Luonnos',
    }, {
      value: 1,
      text: 'Aktiivinen',
    }, {
      value: 2,
      text: 'Toteutunut',
    }, {
      value: 0,
      text: 'Päätetty',
    }],
  }),
  methods: {
    async save() {
      this.savingBuyOrder = true;
      const params = _.cloneDeep(this.buyOrder);
      params.property_type = params.property_type.join(',');
      params.previousStatus = this.currentStatus;
      await apiPost('buyorders/save', params);
      this.savingBuyOrder = false;
      this.buyOrderEditDialog = false;
    },
  },
};
</script>
